import { 
  Target, 
  Calculator, 
  FileText, 
  Wrench, 
  Calendar, 
  ShieldCheck 
} from "lucide-react";

const checks = [
  {
    id: "scope",
    icon: Target,
    name: "Scope Coverage",
    description: "Required work not clearly priced, client-supplied boundaries, temporary works, testing, commissioning, closeout and tender obligations.",
  },
  {
    id: "estimate",
    icon: Calculator,
    name: "Estimate Integrity",
    description: "Totals, formulas, units, broken logic, duplicate allowances, suspicious lump sums, commercial additions and margin/markup treatment.",
  },
  {
    id: "subcontract",
    icon: FileText,
    name: "Supplier & Subcontract Coverage",
    description: "Freight, mobilisation, exclusions, validity periods, testing, scope mismatches and gaps between received quotations and the estimate.",
  },
  {
    id: "buildup",
    icon: Wrench,
    name: "Build-up Sanity",
    description: "Crew composition, productivity, plant, duration, disposal, cartage, waste, methodology and resource assumptions where they materially affect the price.",
  },
  {
    id: "programme",
    icon: Calendar,
    name: "Programme Consistency",
    description: "Estimated labour, plant, supervision and preliminaries compared with the stated construction sequence and duration.",
  },
  {
    id: "release",
    icon: ShieldCheck,
    name: "Commercial Release Gate",
    description: "A clear GO / GO WITH ACTIONS / HOLD result supported by prioritised RED / AMBER / GREEN findings.",
  },
];

export default function WhatWeCheck() {
  return (
    <section
      id="what-we-check"
      className="py-16 md:py-24 border-t-4 border-black bg-white"
      data-testid="what-we-check-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Section header */}
        <div className="mb-12 md:mb-16">
          <span className="font-mono text-sm uppercase tracking-widest text-zinc-500">
            Review Scope
          </span>
          <h2
            className="font-heading font-bold text-3xl sm:text-4xl lg:text-5xl uppercase mt-4"
            data-testid="what-we-check-title"
          >
            What the Review Checks
          </h2>
          <p className="font-body text-zinc-600 mt-4 max-w-2xl">
            Six structured review areas designed to catch commercial exposure before your tender leaves the office.
          </p>
        </div>

        {/* Check cards grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {checks.map((check, index) => (
            <div
              key={check.id}
              className="p-6 md:p-8 border-2 border-black bg-white hover:shadow-brutal transition-shadow"
              data-testid={`check-card-${check.id}`}
            >
              <div className="flex items-center gap-4 mb-4">
                <div className="w-12 h-12 border-2 border-black flex items-center justify-center bg-zinc-50">
                  <check.icon size={24} strokeWidth={1.5} />
                </div>
                <span className="font-mono text-xs text-zinc-400">
                  {String(index + 1).padStart(2, "0")}
                </span>
              </div>
              <h3 className="font-heading font-bold text-lg uppercase mb-3">
                {check.name}
              </h3>
              <p className="font-body text-zinc-600 text-sm leading-relaxed">
                {check.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
